module.exports = __webpack_public_path__ + "img/预留.e20143a9.webp";